import { render, staticRenderFns } from "./CustomerActivityChart.vue?vue&type=template&id=8d748fd4&scoped=true"
import script from "./CustomerActivityChart.vue?vue&type=script&lang=js"
export * from "./CustomerActivityChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d748fd4",
  null
  
)

export default component.exports